import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App.tsx';
import { configureDocStore } from './store/doc-store.ts';
import './styles/index.css';

// Configure the singleton doc store once, before the first render.
// VITE_SYNC_URL is set at build time via Cloudflare Pages env vars.
// Leaving it unset keeps the app in local-only mode (no sync).
configureDocStore({
  syncUrl: import.meta.env.VITE_SYNC_URL ?? null,
  resetSecret: import.meta.env.VITE_SYNC_RESET_SECRET ?? null,
});

const root = document.getElementById('root');
if (!root) throw new Error('missing #root element');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
